import * as React from "react";
import { useTranslation } from "react-i18next";
import Button from "./Button";

interface Props {
    value: boolean;
    onChange(value: boolean): void;
}

export default function ToggleButton({ value, onChange }: Props) {
    const { t } = useTranslation();

    return (
        <>
            <Button text={t("common.yes")} active={value} onClick={() => onChange(true)} />
            <Button text={t("common.no")} active={!value} onClick={() => onChange(false)} />
        </>
    );
}
